<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.supplierProducts'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <div :loading="loading">
        <div v-if="records && records.length != 0">
          <el-row :gutter="5">
            <el-col
              v-for="(row, rowIndex) in records"
              :key="row.id"
              :span="4"
              class="mgt10"
            >
              <el-card :body-style="{ padding: '0px' }">
                <div style="height: 280px">
                  <div class="image-div">
                    <thumbnail
                      :images="row.product.images"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div class="pd8">
                    <el-row class="mgb5">
                      <el-col :span="14" class="overflow">
                        <span v-if="row.hasInv == true" class="orange">
                          (库)
                        </span>
                        <span class="blue" @click="showRow(row)">{{
                          row.product.productNo
                        }}</span>
                      </el-col>
                      <el-col :span="10" class="overflow right">{{
                        row.quoterName
                      }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12" class="overflow">
                        <div style="min-height: 10px">
                          {{ row.product.categoryName }}
                        </div>
                      </el-col>
                      <el-col :span="12" class="overflow right red">
                        <el-popover
                          v-if="row.quotationSizePrices.length != 0"
                          placement="right"
                          width="200"
                          trigger="click"
                        >
                          <div
                            v-for="quotationSizePrice of row.quotationSizePrices"
                            :key="quotationSizePrice.id"
                            class="font14"
                          >
                            {{ quotationSizePrice.size }}：{{
                              quotationSizePrice.price | currency
                            }}
                          </div>

                          <small slot="reference" class="popover-reference">{{
                            row.price | currency
                          }}</small>
                        </el-popover>

                        <span v-else>{{ row.price | currency }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col
                        v-if="Permit.canActions('productManage')"
                        :span="14"
                      >
                        <el-button
                          type="text"
                          :class="row.privatizeAt != null ? 'grey-shallow' : ''"
                          size="mini"
                          @click="privatize(row, rowIndex)"
                          >{{ $t("action.privatize") }}</el-button
                        >
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div v-else class="noData">{{ $t("text.noData") }}</div>
        <div class="flex flex-between pager">
          <div class="selected-qty-tips">
            选中了
            <span class="strong">{{ selectRecordQty }}</span>
            条记录
          </div>
          <div>
            <vxe-pager
              size="small"
              :loading="false"
              :background="false"
              :current-page="pager.currentPage"
              :page-size="pager.pageSize"
              :total="pager.total"
              :layouts="pagerConfig.layouts"
              :page-sizes="pagerConfig.pageSizes"
              @page-change="changePager"
            ></vxe-pager>
          </div>
        </div>
      </div>
    </div>

    <!-- 转化成我的 -->
    <el-dialog
      :title="$t('action.privatize')"
      :visible.sync="privatizeDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="privatizeObjForm" :model="privatizeObj" label-width="60px">
        <el-form-item
          :label="$t('product.productNo')"
          :prop="'productNo'"
          :rules="[
            { required: true, validator: validateProductNo, trigger: 'blur' },
          ]"
        >
          <el-input size="small" v-model.trim="privatizeObj.productNo" />
        </el-form-item>
        <el-form-item
          :label="$t('product.salesPrice')"
          :prop="'salesPrice'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('product.salesPrice')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="privatizeObj.salesPrice" />
        </el-form-item>
        <el-form-item :label="$t('product.category')" :prop="'categoryId'">
          <el-select
            size="small"
            v-model="privatizeObj.categoryId"
            clearable
            filterable
          >
            <el-option
              v-for="c in categories"
              :key="c.name"
              :label="c.name"
              :value="c.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="privatizeDoing"
          size="small"
          @click="privatizeSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="privatizeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>
  </div>
</template>
<script>
import PagerConfig from "@/config/pager.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Supplier from "@/api/supplier.js";
import Quotation from "@/api/quotation.js";
import Category from "@/api/category.js";
import Product from "@/api/product.js";
import Show from "./show.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Thumbnail,
    Show,
    RawHtmlLimitNumber,
  },
  data() {
    var validateProductNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value.trim() === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("product.productNo")]))
        );
        return;
      }
      Product.findByProductNo({ productNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("product.productNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      Util: Util,
      pagerConfig: PagerConfig.product,
      pager: {
        currentPage: 1,
        pageSize: PagerConfig.product.defaultPageSize,
        total: 0,
      },
      narrows: [
        [
          {
            label: this.$t("product.privatizeInfo"),
            items: [
              {
                label: this.$t("privatizeInfos.yes"),
                key: "yes",
                condition: { privatize: "yes" },
              },
              {
                label: this.$t("privatizeInfos.no"),
                key: "no",
                condition: { privatize: "no" },
              },
            ],
          },
        ],
      ],

      // initFilter: "yes",
      searchForm: {
        productNo: null,
      },
      sorter: {
        sortBy: "quotations_id",
        sortIndicator: "desc",
      },
      Util: Util,

      // 转化成我的
      categories: [],
      validateProductNo: validateProductNo,
      privatizeDF: false,
      row: null,
      privatizeObj: {
        productNo: null,
        salesPrice: null,
        categoryId: null,
        showShop: false,
        purchasePrice: null,
        costPrice: null,
        uuid: null,
      },
      privatizeDoing: false,
      //
      currentRowId: null,
      currentRowIdx: null,
      showDF: false,
    };
  },
  created() {
    const self = this;
    Supplier.findByTenantId().then(function (res) {
      if (res.status === 200) {
        if (res.data.length !== 0) {
          self.narrows.push([
            {
              label: self.$t("menu.suppliers"),
              items: res.data.map((supplier) => {
                return {
                  label: supplier.name,
                  key: supplier.id,
                  condition: { supplierId: supplier.id },
                };
              }),
            },
          ]);
        }
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    // 转化成我的
    privatize(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.privatizeDoing = false;
      self.privatizeObj.productNo = row.product.productNo;
      self.privatizeObj.salesPrice = row.price;
      self.privatizeObj.purchasePrice = row.price;
      self.privatizeObj.costPrice = row.price;
      self.privatizeObj.uuid = row.product.uuid;
      Category.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.categories = res.data;
          if (row.privatizeAt == null) {
            self.privatizeDF = true;
          } else {
            if (confirm(this.$t("prompt.confirmPrivatize"))) {
              self.privatizeDF = true;
            }
          }
        } else {
          self.sysError();
        }
      });
    },
    privatizeSubmit() {
      const self = this;
      self.$refs.privatizeObjForm.validate((valid) => {
        if (valid) {
          self.privatizeDoing = true;
          Product.privatize(self.row.id, self.privatizeObj).then(function (
            res
          ) {
            self.privatizeDoing = false;
            self.privatizeDF = false;
            if (res.status === 200) {
              self.addDefaultSupplier(res.data.entity.id);
            } else {
              self.sysError();
            }
            self.records[self.currentRowIdx].privatizeAt = Date.now();
          });
        } else {
          return false;
        }
      });
    },
    addDefaultSupplier(productId) {
      const self = this;
      const obj = {
        productId: productId,
        supplierId: self.row.supplierId,
        price: self.row.price,
        defaultSupplier: true,
        productNo: self.row.product.productNo,
        supplierSizePrices: self.row.quotationSizePrices.map((sp) => {
          return { size: sp.size, price: sp.price };
        }),
      };
      Product.createProductSupplier([obj]).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.privatizeSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    dataProvider(params) {
      return Quotation.inquirierSearch(params);
    },
  },
};
</script>
<style scoped>
.image-div {
  height: 200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.product-checkbox-div {
  position: absolute;
  width: 16%;
}
.product-label-div {
  position: absolute;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.product-label {
  background: #d83732;
  border: 1px solid #d83732;
  margin: 1px 0;
  text-align: left;
  padding: 2px 6px 2px 2px;
  font-size: 12px;
  display: inline-block !important;
  display: inline;
  border-bottom-right-radius: 40px;
  border-top-right-radius: 40px;
  color: #fff;
  opacity: 0.8;
  /* width: auto; */
  /* max-width: 60px; */
  /* overflow: hidden; */
}
</style>